import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useLang } from "../lib/lang";
import { X } from "lucide-react";

export default function GalleryPage() {
  const { t, tri } = useLang();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="App" data-testid="gallery-page">
      <Header />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="border-b border-slate-200 pb-6 mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-red-600 font-semibold mb-2">Archives</div>
          <h1 className="font-display text-5xl sm:text-6xl text-slate-900">{t("nav_gallery")}</h1>
        </div>

        {items.length === 0 ? (
          <div className="text-slate-500 py-12" data-testid="gallery-empty">{t("no_data")}</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {items.map((g, i) => (
              <button
                key={g.id}
                onClick={() => setActive(g)}
                className="group relative aspect-square overflow-hidden bg-slate-100"
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={g.image_url}
                  alt=""
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-slate-900/0 group-hover:bg-slate-900/40 transition" />
              </button>
            ))}
          </div>
        )}
      </div>

      {active && (
        <div
          className="fixed inset-0 z-50 bg-slate-900/95 flex items-center justify-center p-4"
          onClick={() => setActive(null)}
          data-testid="gallery-lightbox"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 w-12 h-12 bg-white text-slate-900 flex items-center justify-center hover:bg-red-600 hover:text-white transition"
            data-testid="gallery-close"
          >
            <X className="w-6 h-6" />
          </button>
          <div onClick={(e) => e.stopPropagation()} className="max-w-5xl w-full">
            <img src={active.image_url} alt="" className="w-full max-h-[80vh] object-contain" />
            <p className="text-white text-center text-sm mt-4" data-testid="gallery-caption">
              {tri(active.caption)}
            </p>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
